import Router from '../utils/router';

import Config from '../configs/main.json';


class RoutingController {

	selector = 'a:not([href*="http"]):not([href*="tel"]):not([data-bypass])';

	constructor() {
		Router.root = Config.root;
	}

	start(routes) {
		Router.start(routes);
	}

	#onAnchorClick = (e) => {
		e.preventDefault();
		Router.navigate(e.currentTarget.getAttribute('href'));
	}

	overrideAnchors(container = document) {
		const anchor = container.querySelectorAll(this.selector);
		for (const a of anchor) {
			a.removeEventListener('click', this.#onAnchorClick);
			a.addEventListener('click', this.#onAnchorClick);
		}
	}

}

export default new RoutingController();
